import { FC } from 'react';

export const InboxStubSvg: FC = () => (
  <svg width="100" height="80" viewBox="0 0 100 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2821_6913)">
      <path d="M31.6362 79.8636V47.168H48.8429V79.8636" stroke="#24275B" stroke-miterlimit="10" />
      <path
        d="M91.6176 26.4521L63.653 70.6051L0.0512695 45.0472V28.3239C0.0512695 16.2701 7.40497 5.42978 18.6155 0.976421C20.2097 0.349043 21.8244 0.0507812 23.398 0.0507812C24.7556 0.0507812 26.0926 0.266764 27.3474 0.67816L28.9621 1.32611L91.6176 26.4521Z"
        fill="#24275B"
      />
      <path
        d="M99.9486 56.2065L63.6738 70.6054V53.8718C63.6738 41.8077 71.0275 30.9777 82.2381 26.5243C90.7231 23.1509 99.9384 29.4041 99.9384 38.5474V56.2065H99.9486Z"
        fill="#E7E9F4"
        stroke="#E7E9F4"
        stroke-miterlimit="10"
      />
      <path
        d="M56.8829 53.774C57.2751 53.771 57.5895 53.2977 57.5851 52.7168C57.5806 52.1359 57.2591 51.6674 56.8669 51.6704C56.4747 51.6734 56.1603 52.1467 56.1648 52.7276C56.1692 53.3085 56.4907 53.777 56.8829 53.774Z"
        fill="white"
      />
      <path
        d="M58.1713 52.7211C58.1725 53.3696 57.9952 53.9346 57.7338 54.3234C57.4704 54.7152 57.1589 54.8836 56.8791 54.8841C56.5993 54.8846 56.2871 54.7174 56.0222 54.3267C55.7593 53.9388 55.5799 53.3744 55.5787 52.726C55.5775 52.0775 55.7548 51.5125 56.0162 51.1237C56.2796 50.7319 56.5912 50.5636 56.8709 50.563C57.1507 50.5625 57.4629 50.7297 57.7278 51.1205C57.9907 51.5083 58.1701 52.0727 58.1713 52.7211Z"
        stroke="#E7E9F4"
      />
      <path d="M21.9688 38.6328L57.0608 52.7231" stroke="white" stroke-miterlimit="10" />
      <path d="M31.7046 48.4626L21.6665 44.4413V38.332L31.7046 42.3534V48.4626Z" fill="white" />
      <path
        d="M96.5672 43.62C96.5672 44.4396 96.0672 45.1763 95.3054 45.4788L70.4345 55.3565C69.778 55.6172 69.0654 55.1335 69.0654 54.4271V53.4833C69.0654 52.6637 69.5655 51.9271 70.3272 51.6245L95.1981 41.7469C95.8546 41.4861 96.5672 41.9698 96.5672 42.6763V43.62Z"
        fill="#24275B"
      />
    </g>
    <defs>
      <clipPath id="clip0_2821_6913">
        <rect width="100" height="79.8622" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
